// src/macroSpecialities.ts
var macroSpecialities = {
  DEFAULT: { label: "Medico di telemedicina", synonyms: [] },
  DEFAULT_NURSE: { label: "Infermiere", synonyms: [] },
  COUNSELOR: { label: "Counselor", synonyms: [] },
  GENERAL_MEDICINE: { label: "Medicina generale", synonyms: [] },
  PSYCHOLOGY: { label: "Psicologia", synonyms: ["Psicologo", "Psicologa"] },
  PEDIATRICS: { label: "Pediatria", synonyms: ["pediatra"] },
  ACUPUNCTURE: { label: "Agopuntura", synonyms: [] },
  ALLERGOLOGY: { label: "Allergologia", synonyms: ["allergologo", "allergologa"] },
  ANDROLOGY: { label: "Andrologia", synonyms: ["andrologo", "androloga"] },
  ANESTHESIA: { label: "Anestesia", synonyms: [] },
  ANGIOLOGY: { label: "Angiologia", synonyms: ["angiologo"] },
  CARDIOLOGY: { label: "Cardiologia", synonyms: ["cardiologia", "cardiologo", "cardiologa"] },
  CARDIAC_SURGERY: { label: "Chirurgia cardiaca", synonyms: [] },
  GENERAL_SURGERY: { label: "Chirurgia Generale", synonyms: [] },
  MAXILLOFACIAL_SURGERY: { label: "Chirurgia Maxillo-Facciale", synonyms: [] },
  PEDIATRIC_SURGERY: { label: "Chirurgia pediatrica", synonyms: [] },
  THORACIC_SURGERY: { label: "Chirurgia Toracica", synonyms: [] },
  DERMATOLOGY_AND_VENEREOLOGY: {
    label: "Dermatologia e Venereologia",
    synonyms: ["Dermatologo", "Dermatologa", "Venereologo", "Venereologa", "Dermatologia", "Venereologia"]
  },
  HEMATOLOGY: { label: "Ematologia", synonyms: ["ematologo", "ematologa"] },
  ENDOCRINOLOGY_AND_METABOLIC_DISEASES: {
    label: "Endocrinologia e malattie del metabolismo",
    synonyms: ["endocrinologo", "endocrinologa"]
  },
  PHYSIOTHERAPY: { label: "Fisioterapia", synonyms: ["Fisioterapista"] },
  GASTROENTEROLOGY: { label: "Gastroenterologia", synonyms: ["gastroenterologo"] },
  GERIATRICS: { label: "Geriatria", synonyms: ["geriatra"] },
  GYNECOLOGY_AND_OBSTETRICS: {
    label: "Ginecologia ed Ostetricia",
    synonyms: ["Ginecologo", "Ginecologa", "Ginecologia", "Ostetricia", "Ostetrico", "Ostetrica"]
  },
  HYGIENE_AND_PREVENTIVE_MEDICINE: { label: "Igiene e Medicina Preventiva", synonyms: [] },
  IMMUNOLOGY: { label: "Immunologia", synonyms: [] },
  INFECTIOUS_DISEASE_AND_TROPICAL_DISEASES: { label: "Infettivologia e Malattie tropicali", synonyms: [] },
  SPEECH_THERAPY: { label: "Logopedia", synonyms: ["logopedista"] },
  DISEASES_OF_THE_CARDIOVASCULAR_SYSTEM: { label: "Malattie dell'apparato cardiovascolare", synonyms: [] },
  DISEASES_OF_THE_DIGESTIVE_SYSTEM: { label: "Malattie dell'apparato digerente", synonyms: [] },
  DISEASES_OF_THE_RESPIRATORY_SYSTEM: { label: "Malattie dell'apparato respiratorio", synonyms: [] },
  EMERGENCY_URGENCY_MEDICINE: { label: "Medicina d'emergenza-urgenza", synonyms: [] },
  OCCUPATIONAL_MEDICINE: { label: "Medicina del Lavoro", synonyms: [] },
  SPORTS_MEDICINE: { label: "Medicina dello sport", synonyms: [] },
  INTERNAL_MEDICINE: { label: "Medicina interna", synonyms: [] },
  FORENSIC_MEDICINE: { label: "Medicina Legale", synonyms: [] },
  THERMAL_MEDICINE: { label: "Medicina termale", synonyms: [] },
  NEPHROLOGY: { label: "Nefrologia", synonyms: [] },
  NEUROLOGY: { label: "Neurologia", synonyms: ["neurologo", "neurologa"] },
  NEUROPSYCHIATRY: { label: "Neuropsichiatria", synonyms: ["neuropsichiatra"] },
  NUTRITION: { label: "Nutrizione", synonyms: ["nutrizionista"] },
  DENTISTRY: { label: "Odontoiatria", synonyms: ["Dentista", "Igienista", "Odontoiatra"] },
  OPHTHALMOLOGY: { label: "Oculistica", synonyms: ["Oculista, Oftalmologia"] },
  ONCOLOGY: { label: "Oncologia", synonyms: ["oncologo", "oncologa"] },
  ORTHOPEDICS_AND_TRAUMATOLOGY: { label: "Ortopedia e traumatologia", synonyms: ["ortopedico", "ortopedica"] },
  OSTEOPATHY: { label: "Osteopatia", synonyms: ["Osteopata"] },
  OBSTETRICS: { label: "Ostetricia", synonyms: [] },
  OTOLARYNGOLOGY: { label: "Otorinolaringoiatria", synonyms: ["otorino", "otorinolaringoiatria"] },
  PNEUMOLOGY: { label: "Pneumologia", synonyms: ["pneumologa", "pneumologo"] },
  PODIATRY: { label: "Podologia", synonyms: ["podologo", "podologa"] },
  PROCTOLOGY: { label: "Proctologia", synonyms: ["proctologo", "proctologa"] },
  PSYCHIATRY: { label: "Psichiatria", synonyms: ["psichiatra"] },
  RADIOLOGY: { label: "Radiologia", synonyms: [] },
  RHEUMATOLOGY: { label: "Reumatologia", synonyms: ["Reumatologo", "Reumatologa"] },
  ORTHOPEDIC_REHABILITATION: { label: "Riabilitazione Ortopedica", synonyms: ["ortopedico", "ortopedica"] },
  NEUROLOGICAL_REHABILITATION: { label: "Riabilitazione Neurologica", synonyms: [] },
  SPORT_PERFORMANCE_REHABILITATION: { label: "Riabilitazione Sport/Performance", synonyms: [] },
  PHARMACEUTICAL_SCIENCES: { label: "Scienze Farmaceutiche", synonyms: [] },
  SENOLOGY: { label: "Senologia", synonyms: [] },
  TUMORS_OF_THE_HEAD_AND_NECK: { label: "Tumori della testa e del collo", synonyms: [] },
  UROLOGY: { label: "Urologia", synonyms: ["Urologo", "Urologa"] },
  PAIN_THERAPY: { label: "Terapia del dolore", synonyms: [] },
  AESTHETIC_MEDICINE: { label: "Medicina estetica", synonyms: [] },
  NUCLEAR_MEDICINE: { label: "Medicina Nucleare", synonyms: [] },
  SEXOLOGY: { label: "Sessuologia", synonyms: [] },
  CHIROPRATIC: { label: "Chiropratica", synonyms: ["chiropratico", "chiropratica"] },
  HOMEOPATHY: { label: "Omeopatia", synonyms: [] },
  DIETICS: { label: "Dietistica", synonyms: [] },
  PLASTIC_SURGERY: { label: "Chirurgia Plastica", synonyms: [] },
  GENETICS: { label: "Genetica", synonyms: [] },
  PHYSIATRY: { label: "Fisiatria", synonyms: ["fisiatra"] },
  ORTHOPTISTIC: { label: "Ortottistica", synonyms: [] },
  DIAGNOSTICS: { label: "Diagnostica", synonyms: [] },
  MASSOTHERAPY: { label: "Massoterapia", synonyms: [] },
  NURSING: { label: "Infermieristica", synonyms: [] },
  ECOGRAPHY: { label: "Ecografia", synonyms: [] },
  PEDIATRIC_ORTHOPEDICS: { label: "Ortopedia pediatrica", synonyms: [] },
  CLINICAL_ANALYSIS: { label: "Analisi cliniche", synonyms: [] }
};

export { macroSpecialities };
